export function mapToRecord<TValue>(
  array: TValue[],
  getKey: (item: TValue) => number | string
): Record<number | string, TValue> {
  return array.reduce<Record<number | string, TValue>>((acc, item) => {
    acc[getKey(item)] = item;
    return acc;
  }, {});
}
